// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <h2
            class="MuiTypography-root MuiTypography-h2"
          >
            Invoice details
          </h2>
          <p
            class="MuiTypography-root MuiTypography-body1"
          >
            These details are used for the purposes of creating this invoice and are not saved.
          </p>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item"
        >
          <div
            class="MuiFormControl-root"
          >
            <form
              id="private-invoice-form"
            >
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-4"
              >
                <div
                  class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
                >
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <h4
                      class="MuiTypography-root MuiTypography-h4"
                    >
                      Your details
                    </h4>
                    <p
                      class="MuiTypography-root MuiTypography-body1"
                    >
                      This address is where the patient will mail their payment via cheque.
                    </p>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        Name on invoice
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.name"
                          rows="1"
                          type="text"
                          value="user name"
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              Name on invoice
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                        data-shrink="false"
                      >
                        Street address 1
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.address1"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Street address 1
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined"
                        data-shrink="false"
                      >
                        Street address 2 (optional)
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.address2"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Street address 2 (optional)
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                        data-shrink="false"
                      >
                        City
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.city"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              City
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                        data-shrink="false"
                      >
                        Province / state
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.province"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Province / state
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                        data-shrink="false"
                      >
                        Postal / zip code
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.postalCode"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Postal / zip code
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined"
                        data-shrink="false"
                      >
                        Email (optional)
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.email"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Email (optional)
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                        data-shrink="false"
                      >
                        Phone
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="user.phone"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Phone
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
                >
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <h4
                      class="MuiTypography-root MuiTypography-h4"
                    >
                      Patient details
                    </h4>
                    <p
                      class="MuiTypography-root MuiTypography-body1"
                    />
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        Patient name
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="patient.name"
                          rows="1"
                          type="text"
                          value="patient name"
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              Patient name
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        Street address 1
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="patient.address1"
                          rows="1"
                          type="text"
                          value="patient address1"
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              Street address 1
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined"
                        data-shrink="false"
                      >
                        Street address 2 (optional)
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="patient.address2"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Street address 2 (optional)
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        City
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="patient.city"
                          rows="1"
                          type="text"
                          value="patient city"
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              City
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        Province / state
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="patient.province"
                          rows="1"
                          type="text"
                          value="patient province"
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              Province / state
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        Postal / zip code
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="patient.postalCode"
                          rows="1"
                          type="text"
                          value="patient postalCode"
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              Postal / zip code
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        Country
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="patient.country"
                          rows="1"
                          type="text"
                          value="patient country"
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              Country
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
                >
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <h4
                      class="MuiTypography-root MuiTypography-h4"
                    >
                      Invoice details
                    </h4>
                    <p
                      class="MuiTypography-root MuiTypography-body1"
                    />
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                        data-shrink="false"
                      >
                        Invoice number
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input"
                          name="invoiceDetails.number"
                          rows="1"
                          type="text"
                          value=""
                        />
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6"
                          >
                            <span>
                              Invoice number
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                      <p
                        class="MuiFormHelperText-root MuiFormHelperText-contained"
                      >
                        Enter any number that makes sense for your records, e.g 001
                      </p>
                    </div>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                    >
                      <label
                        class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                        data-shrink="true"
                      >
                        Terms
                        <span
                          aria-hidden="true"
                          class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                        >
                           
                          *
                        </span>
                      </label>
                      <div
                        class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-multiline MuiOutlinedInput-multiline"
                      >
                        <textarea
                          aria-invalid="false"
                          class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline MuiOutlinedInput-inputMultiline"
                          name="invoiceDetails.terms"
                          rows="3"
                        >
                          Payment is due 30 days after invoice date. Payment method is below. See payment stub for details.
                        </textarea>
                        <fieldset
                          aria-hidden="true"
                          class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                        >
                          <legend
                            class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                          >
                            <span>
                              Terms
                               *
                            </span>
                          </legend>
                        </fieldset>
                      </div>
                      <p
                        class="MuiFormHelperText-root MuiFormHelperText-contained MuiFormHelperText-filled"
                      >
                        Enter terms that make sense for your practice - 30, 60, 90 days, etc.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div
          class="MuiGrid-root makeStyles-cardGrid-2 MuiGrid-item"
        >
          <div
            class="MuiPaper-root MuiCard-root makeStyles-cardBackground-3 makeStyles-noBorder-1 MuiPaper-outlined MuiPaper-rounded"
          >
            <div
              class="MuiGrid-root MuiGrid-container"
            >
              <div
                class="MuiGrid-root MuiGrid-item"
              >
                <div
                  class="MuiCardContent-root"
                >
                  <h6
                    class="MuiTypography-root MuiTypography-h6"
                  >
                    Create your invoice
                  </h6>
                  <p
                    class="MuiTypography-root MuiTypography-body1"
                  >
                    Your invoice will open in a new window for you to save and print. When you're happy with the invoice, you can close this screen.
                  </p>
                </div>
              </div>
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end MuiGrid-grid-xs-12"
              >
                <div
                  class="MuiCardActions-root MuiCardActions-spacing"
                >
                  <button
                    class="MuiButtonBase-root MuiButton-root MuiButton-text"
                    tabindex="0"
                    type="button"
                  >
                    <span
                      class="MuiButton-label"
                    >
                      Close
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </button>
                  <button
                    class="MuiButtonBase-root MuiButton-root MuiButton-text"
                    tabindex="0"
                    type="button"
                  >
                    <span
                      class="MuiButton-label"
                    >
                      Back
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </button>
                  <button
                    class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                    form="private-invoice-form"
                    tabindex="0"
                    type="submit"
                  >
                    <span
                      class="MuiButton-label"
                    >
                      Create Invoice
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
    >
      <div
        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
      >
        <h2
          class="MuiTypography-root MuiTypography-h2"
        >
          Invoice details
        </h2>
        <p
          class="MuiTypography-root MuiTypography-body1"
        >
          These details are used for the purposes of creating this invoice and are not saved.
        </p>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item"
      >
        <div
          class="MuiFormControl-root"
        >
          <form
            id="private-invoice-form"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-4"
            >
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
              >
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <h4
                    class="MuiTypography-root MuiTypography-h4"
                  >
                    Your details
                  </h4>
                  <p
                    class="MuiTypography-root MuiTypography-body1"
                  >
                    This address is where the patient will mail their payment via cheque.
                  </p>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      Name on invoice
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.name"
                        rows="1"
                        type="text"
                        value="user name"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            Name on invoice
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                      data-shrink="false"
                    >
                      Street address 1
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.address1"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Street address 1
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined"
                      data-shrink="false"
                    >
                      Street address 2 (optional)
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.address2"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Street address 2 (optional)
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                      data-shrink="false"
                    >
                      City
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.city"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            City
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                      data-shrink="false"
                    >
                      Province / state
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.province"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Province / state
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                      data-shrink="false"
                    >
                      Postal / zip code
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.postalCode"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Postal / zip code
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined"
                      data-shrink="false"
                    >
                      Email (optional)
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.email"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Email (optional)
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                      data-shrink="false"
                    >
                      Phone
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="user.phone"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Phone
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
              >
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <h4
                    class="MuiTypography-root MuiTypography-h4"
                  >
                    Patient details
                  </h4>
                  <p
                    class="MuiTypography-root MuiTypography-body1"
                  />
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      Patient name
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="patient.name"
                        rows="1"
                        type="text"
                        value="patient name"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            Patient name
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      Street address 1
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="patient.address1"
                        rows="1"
                        type="text"
                        value="patient address1"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            Street address 1
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined"
                      data-shrink="false"
                    >
                      Street address 2 (optional)
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="patient.address2"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Street address 2 (optional)
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      City
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="patient.city"
                        rows="1"
                        type="text"
                        value="patient city"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            City
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      Province / state
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="patient.province"
                        rows="1"
                        type="text"
                        value="patient province"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            Province / state
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      Postal / zip code
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="patient.postalCode"
                        rows="1"
                        type="text"
                        value="patient postalCode"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            Postal / zip code
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      Country
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="patient.country"
                        rows="1"
                        type="text"
                        value="patient country"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            Country
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
              >
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <h4
                    class="MuiTypography-root MuiTypography-h4"
                  >
                    Invoice details
                  </h4>
                  <p
                    class="MuiTypography-root MuiTypography-body1"
                  />
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                      data-shrink="false"
                    >
                      Invoice number
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input"
                        name="invoiceDetails.number"
                        rows="1"
                        type="text"
                        value=""
                      />
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6"
                        >
                          <span>
                            Invoice number
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                    <p
                      class="MuiFormHelperText-root MuiFormHelperText-contained"
                    >
                      Enter any number that makes sense for your records, e.g 001
                    </p>
                  </div>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                  >
                    <label
                      class="MuiFormLabel-root MuiInputLabel-root required-label MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
                      data-shrink="true"
                    >
                      Terms
                      <span
                        aria-hidden="true"
                        class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                      >
                         
                        *
                      </span>
                    </label>
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-multiline MuiOutlinedInput-multiline"
                    >
                      <textarea
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline MuiOutlinedInput-inputMultiline"
                        name="invoiceDetails.terms"
                        rows="3"
                      >
                        Payment is due 30 days after invoice date. Payment method is below. See payment stub for details.
                      </textarea>
                      <fieldset
                        aria-hidden="true"
                        class="PrivateNotchedOutline-root-4 MuiOutlinedInput-notchedOutline"
                      >
                        <legend
                          class="PrivateNotchedOutline-legendLabelled-6 PrivateNotchedOutline-legendNotched-7"
                        >
                          <span>
                            Terms
                             *
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                    <p
                      class="MuiFormHelperText-root MuiFormHelperText-contained MuiFormHelperText-filled"
                    >
                      Enter terms that make sense for your practice - 30, 60, 90 days, etc.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div
        class="MuiGrid-root makeStyles-cardGrid-2 MuiGrid-item"
      >
        <div
          class="MuiPaper-root MuiCard-root makeStyles-cardBackground-3 makeStyles-noBorder-1 MuiPaper-outlined MuiPaper-rounded"
        >
          <div
            class="MuiGrid-root MuiGrid-container"
          >
            <div
              class="MuiGrid-root MuiGrid-item"
            >
              <div
                class="MuiCardContent-root"
              >
                <h6
                  class="MuiTypography-root MuiTypography-h6"
                >
                  Create your invoice
                </h6>
                <p
                  class="MuiTypography-root MuiTypography-body1"
                >
                  Your invoice will open in a new window for you to save and print. When you're happy with the invoice, you can close this screen.
                </p>
              </div>
            </div>
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end MuiGrid-grid-xs-12"
            >
              <div
                class="MuiCardActions-root MuiCardActions-spacing"
              >
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-text"
                  tabindex="0"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    Close
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-text"
                  tabindex="0"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    Back
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                  form="private-invoice-form"
                  tabindex="0"
                  type="submit"
                >
                  <span
                    class="MuiButton-label"
                  >
                    Create Invoice
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
